import request from '@/js/request'
export default {
    namespaced: true,
    state: {
        handle: '',
        unread: 0,
    },
    getters: {
        get_unread(state) {
            return state.unread
        }
    },
    mutations: {
        setHandle(state, payload) {
            state.handle = payload
        },
        setUnread(state, payload) {
            state.unread = payload
        },
    },
    actions: {
        async register_messageListen({ commit, state, getters }, interval) {
            try {
                clearInterval(state.handle)
                const handleProc = async () => {
                    try {
                        const result = await request({
                            url: '/api/life/noReadCount',
                            method: 'GET',
                        })
                        commit('setUnread', result)
                    } catch (e) {
                        return Promise.reject(e)
                    }
                }
                handleProc()
                const handle = setInterval(handleProc, interval);
                commit('setHandle', handle)
            } catch (error) {
                return Promise.reject(error)
            }
        },
    }
}